import React, { useState } from "react"
import Img from "gatsby-image/withIEPolyfill"
import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"
import Fade from "react-reveal/Fade"

const WorkItem = ({
  isLangEn,
  workTitle,
  workSlug,
  workImage,
  workContent,
  workNum,
}) => {
  const [isCaption, setIsCaption] = useState(false)
  const [isModal, setIsModal] = useState(false)

  const handleOpen = () => {
    setIsModal(true)
  }

  const handleClose = () => {
    setIsModal(false)
  }

  return (
    <>
      <button
        className={`works__item works__item--${workSlug}`}
        aria-label="Show Work"
        onClick={handleOpen}
      >
        <Fade delay={workNum}>
          <figure className="works__item__image" role="figure">
            <Img fluid={workImage} alt={workTitle} />
            <div
              className={`works__item__caption ${isCaption ? "active" : ""}`}
              role="button"
              aria-pressed="false"
              tabIndex={0}
              onMouseEnter={() => setIsCaption(true)}
              onMouseLeave={() => setIsCaption(false)}
            >
              <figcaption className="caption__title">{workTitle}</figcaption>
            </div>
          </figure>
        </Fade>
      </button>

      <Modal
        open={isModal}
        onClose={handleClose}
        center
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <div className={workSlug}>
          <h2 className="modal__head">{workTitle}</h2>
          <div className="modal__content">
            {workContent}
            <div className="button__wrapper">
              <div
                onClick={handleClose}
                onKeyDown={handleClose}
                className="close__button"
                role="button"
                tabIndex={-1}
              >
                <span className="close__ico">×</span>
                {isLangEn ? "CLOSE" : "閉じる"}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default WorkItem
